module.exports = __webpack_public_path__ + "static/media/biocair.7a3718b8.png";